import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import '../styles/normalize.scss';
import '../styles/globals.scss';
import themeStyle from '../styles/theme';
import Head from 'next/head';
import App from 'next/app';
import cookie from 'cookie';
import { AuthProvider } from '@/providers/Auth';
import { Settings } from 'luxon';
import TagManager from 'react-gtm-module';
import { getDeviceType, solveUserAgent, getGtmId } from '@/helpers';
import UserContext from '../components/User/User';
import Cookies from 'universal-cookie';
import { GlobalStyles } from 'condolivre-ds';
import DeviceProvider from '../components/DeviceProvider/DeviceProvider';
import { setConfiguration } from 'react-grid-system';
import GoogleTagManager from '@/components/GoogleTagManager/GoogleTagManager';
import { useRouter } from 'next/router';

setConfiguration({
    breakpoints: [576, 768, 992, 1200, 1600, 1920],
    containerWidths: [540, 740, 960, 1140, 1540, 1810]
});

Settings.defaultLocale = 'pt-BR';

MyApp.propTypes = {
    pageProps: PropTypes.object,
    user: PropTypes.string,
    authenticated: PropTypes.bool,
    loading: PropTypes.bool,
    deviceType: PropTypes.string,
    Component: PropTypes.func
};

function MyApp({ Component, pageProps, authenticated, user, deviceType, gtmId }) {
    const router = useRouter();

    useEffect(() => {
        import('react-facebook-pixel')
            .then((x) => x.default)
            .then((ReactPixel) => {
                ReactPixel.init('931493264703026');
                ReactPixel.pageView();

                router.events.on('routeChangeComplete', () => {
                    ReactPixel.pageView();
                });
            });
    }, [router.events]);

    useEffect(() => {
        TagManager.initialize({ gtmId: 'GTM-KKFJQKK' });
    }, []);

    const [refresh, setRefresh] = useState(false);

    useEffect(() => {
        setTimeout(function () {
            setRefresh(true);
        }, 100);
    }, []);

    return (
        <>
            <Head>
                <title>Condo Livre</title>
            </Head>
            {gtmId && <GoogleTagManager tagId={gtmId} />}
            {refresh && (
                <GlobalStyles theme={themeStyle}>
                    <AuthProvider authenticated={authenticated}>
                        <DeviceProvider value={deviceType}>
                            <UserContext.Provider value={user}>
                                <Component {...pageProps} />
                            </UserContext.Provider>
                        </DeviceProvider>
                    </AuthProvider>
                </GlobalStyles>
            )}
        </>
    );
}

MyApp.getInitialProps = async (appContext) => {
    let authenticated = false;
    const cookies = new Cookies();
    const newUser = cookies.get('user');
    let user = JSON.stringify(newUser);

    const request = appContext.ctx.req;

    if (request) {
        request.cookies = cookie.parse(request.headers.cookie || '');
        authenticated = !!request.cookies.session;
        user = request.cookies.user;
    }

    if (!user) {
        return {
            redirect: {
                destination: '/login',
                permanent: false
            }
        };
    }

    const userAgent = solveUserAgent(request);
    const deviceType = getDeviceType(userAgent);
    const GTM_ID = getGtmId();
    const appProps = await App.getInitialProps(appContext);
    return {
        ...appProps,
        authenticated,
        user,
        deviceType,
        gtmId: GTM_ID
    };
};

export default MyApp;
